/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.DataTable";
        const THRESHOLD_HEIGHT = 50;
        class ComponentDataTable extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, maxHeight = null) {
                super(core, container, parent);
                this._componentDiv = null;
                this._dataTable = null;
                this._headerRow = null;
                this._filterRow = null;
                this._filterSettings = null;
                this._maxHeight = null;
                this._isReady = null;
                this._currentTableData = null;
                this._isWaitingDisplayData = null;
                this._dataTableReady = null;
                this._isWaitingShowFilter = null;
                this._isWaitingHideFilter = null;
                this._isWaitingClearSelection = null;
                this._isWaitingCopyToClipboard = null;
                this._isWaitingSaveCsv = null;
                this._componentResizeObserver = null;
                this._maxHeightResizeObserver = null;
                this._headerWidthResizeObserver = null;
                this._initialWidth = null;
                this._headerDiv = null;
                this._headerTable = null;
                this._headerInnerDiv = null;
                this._bodyTable = null;
                this._bodyDiv = null;
                this._infoDivs = null;
                this._pageLength = 10;
                // To be called when the table is populated or filtered 
                this._visibleDataInitialisedCallback = null;
                this._visibleDataFilteredCallback = null;
                // This is called a lot more than I'd like but not sure yet if there's a way to thin it out by source event
                this._visibleDataChanged = () => {
                    this._log.info("DataTableComponent._visibleDataChanged()");
                    this._fireVisibleDataChangedCallbacks('filter');
                };
                this._fireVisibleDataChangedCallbacks = (producedBy) => {
                    this._log.info("DataTableComponent._fireVisibleDataChangedCallbacks()");
                    if (!producedBy)
                        return;
                    if ((producedBy == 'initial') && (!this._visibleDataInitialisedCallback))
                        return;
                    if ((producedBy == 'filter') && (!this._visibleDataFilteredCallback))
                        return;
                    // Encapsulate data in the appropriate format
                    // We may want to copy the columns object here to avoid it being messed up externally, but trying to avoid for performance reasons
                    let dataResponse = {
                        ProducedBy: producedBy,
                        Columns: [],
                        RowData: []
                    };
                    // Column headers - shame we can't get data types, also worried about labels/translations here
                    this._currentTableData.Columns.forEach(col => {
                        dataResponse.Columns.push(col.Title);
                    });
                    // Pull main values from filtered rows
                    let internalRows = this._dataTable.rows({ search: 'applied' }).data();
                    for (let i = 0; i < internalRows.length; i++) {
                        let extractedValues = [];
                        internalRows[i].Values.forEach(internalCol => {
                            extractedValues.push(internalCol.Value);
                        });
                        dataResponse.RowData.push(extractedValues);
                    }
                    if (producedBy == 'initial')
                        this._visibleDataInitialisedCallback(dataResponse);
                    else
                        this._visibleDataFilteredCallback(dataResponse);
                };
                this.displayData = (data) => {
                    this._log.info("DataTableComponent.displayData()");
                    this._currentTableData = this._sanitiseData(data);
                    if (this._isReady)
                        this._displayData();
                    else
                        this._isWaitingDisplayData = true;
                };
                this.showFilterRow = () => {
                    this._log.info("DataTableComponent.showFilterRow()");
                    if (!this._dataTableReady)
                        this._isWaitingShowFilter = true;
                    else {
                        this._core.Functions.showElement(this._filterRow);
                    }
                };
                this.hideFilterRow = () => {
                    this._log.info("DataTableComponent.hideFilterRow()");
                    if (!this._dataTableReady)
                        this._isWaitingHideFilter = true;
                    else {
                        this._core.Functions.hideElement(this._filterRow);
                        this._clearFilter();
                    }
                };
                this.clearRowSelection = (preventQueueing = false) => {
                    this._log.info("DataTableComponent.clearRowSelection()");
                    if (!this._dataTableReady) {
                        if (!preventQueueing)
                            this._isWaitingClearSelection = true;
                    }
                    else {
                        this._dataTable.rows("." + Widgets.WIDGET_SELECTED_CLASS).nodes().toJQuery().removeClass(Widgets.WIDGET_SELECTED_CLASS);
                    }
                };
                this.copyDataToClipboard = () => {
                    this._log.info("DataTableComponent.copyDataToClipboard()");
                    if (!this._dataTableReady)
                        this._isWaitingCopyToClipboard = true;
                    else {
                        this._dataTable.button("copy:name").trigger();
                    }
                };
                this.saveDataAsCSV = () => {
                    this._log.info("DataTableComponent.saveDataAsCSV()");
                    if (!this._dataTableReady)
                        this._isWaitingSaveCsv = true;
                    else {
                        this._dataTable.button("csv:name").trigger();
                    }
                };
                this._present = () => {
                    this._log.info("DataTableComponent._present()");
                    this._container.innerHTML = ComponentDataTable.Html;
                    this._componentDiv = this._container.querySelector('.widget-component--data-table');
                    this._isReady = true;
                    if (this._isWaitingDisplayData)
                        this._displayData();
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DataTableComponent._storeHtml()");
                    ComponentDataTable.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._sanitiseData = (data) => {
                    this._log.info("DataTableComponent._sanitiseData()");
                    let result = {
                        Settings: data.Settings,
                        Columns: data.Columns,
                        Rows: []
                    };
                    let rowLength = data.Rows.length;
                    for (let i = 0; i < rowLength; i++) {
                        let row = data.Rows[i];
                        let rowValues = [];
                        let rowData = {
                            Values: rowValues,
                            Metadata: row.Metadata,
                            ClickCallback: row.ClickCallback,
                            CreatedCallback: row.CreatedCallback
                        };
                        let valueLength = row.Values.length;
                        for (let v = 0; v < valueLength; v++) {
                            let cellData = row.Values[v];
                            let preventSanitising = false;
                            if (cellData.hasOwnProperty('PreventSanitising') && cellData.PreventSanitising != null) {
                                preventSanitising = cellData.PreventSanitising;
                            }
                            let sanitisedCellData = {
                                Value: cellData.Value,
                                Display: preventSanitising ? cellData.Display : this._core.Functions.safeEncodeHTMLContent(cellData.Display),
                                Sort: cellData.Sort,
                                Filter: cellData.Filter
                            };
                            rowData.Values.push(sanitisedCellData);
                        }
                        result.Rows.push(rowData);
                    }
                    return result;
                };
                this._displayData = () => {
                    var _a, _b, _c, _d;
                    this._log.info("DataTableComponent._displayData()");
                    if (this._dataTable) {
                        this._dataTable.clear().destroy(true);
                        (_a = this._componentResizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
                        (_b = this._maxHeightResizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
                        (_c = this._headerWidthResizeObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
                        this._dataTableReady = false;
                        this._initialWidth = null;
                    }
                    this._componentDiv.innerHTML = "";
                    let table = document.createElement('table');
                    this._componentDiv.appendChild(table);
                    table.id = "dataTable";
                    table.classList.add("table", "table-hover", "table-striped", "nowrap");
                    let settings = {};
                    let columns = [];
                    let rows = [];
                    if (this._currentTableData.Columns.length === 0) {
                        let unknownColumnSetting = {
                            Title: this._core.Locale.getTranslation("STR_WPT_DT_ZERO")
                        };
                        this._currentTableData.Columns.push(unknownColumnSetting);
                    }
                    settings.paging = true;
                    if (this._currentTableData.Settings) {
                        if (this._currentTableData.Settings.Order) {
                            settings.order = this._currentTableData.Settings.Order;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using order: " + JSON.stringify(settings.order));
                            }
                        }
                        if (this._currentTableData.Settings.hasOwnProperty('Paging') && this._currentTableData.Settings.Paging != null) {
                            settings.paging = this._currentTableData.Settings.Paging;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using paging: " + settings.paging);
                            }
                        }
                    }
                    this._filterSettings = [];
                    let columnLength = this._currentTableData.Columns.length;
                    for (let i = 0; i < columnLength; i++) {
                        let column = this._currentTableData.Columns[i];
                        let columnSetting = {
                            title: column.Title,
                            data: {
                                "_": "Values." + i + ".Value",
                                "display": "Values." + i + ".Display",
                                "sort": "Values." + i + ".Sort",
                                "filter": "Values." + i + ".Filter"
                            }
                        };
                        if (column.hasOwnProperty('Orderable') && column.Orderable != null) {
                            columnSetting.orderable = column.Orderable;
                        }
                        if (column.hasOwnProperty('Visible') && column.Visible != null) {
                            columnSetting.visible = column.Visible;
                        }
                        columns.push(columnSetting);
                        if (column.hasOwnProperty('FilterType') && column.FilterType) {
                            this._filterSettings[column.Title] = column.FilterType;
                        }
                    }
                    rows = this._currentTableData.Rows;
                    settings.columns = columns;
                    settings.data = rows;
                    settings.orderCellsTop = true;
                    if (settings.paging) {
                        settings.dom = "<'row row-no-gutters dataTable-info'<'col-xs-6'l><'col-xs-6'i>><'row row-no-gutters'<'col-xs-12't>><'row row-no-gutters dataTable-info'<'col-xs-12'p>>";
                    }
                    else {
                        settings.dom = "<'row row-no-gutters'<'col-xs-12't>>";
                    }
                    // TODO: look at different "modes"
                    // (settings as any).responsive = true;  // instead of scrollX
                    // (settings as any).responsive = {
                    //     details: {
                    //         display: ($.fn.dataTable as any).Responsive.display.modal()
                    //     }
                    // };
                    settings.scrollX = true;
                    if (this._maxHeight !== null && this._maxHeight > 0) {
                        let resultingHeight = this._maxHeight - 1; // remove 1 pixel to avoid unnecessary scrollbar
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("started with height " + this._maxHeight + " and ended with: " + resultingHeight);
                        }
                        if (resultingHeight > 0) {
                            settings.scrollCollapse = true;
                            settings.scrollY = resultingHeight + "px";
                        }
                    }
                    settings.lengthMenu = [[-1, 5, 10, 15, 20, 30, 40, 50, 75, 100], [this._core.Locale.getTranslation('STR_WPT_ALL'), 5, 10, 15, 20, 30, 40, 50, 75, 100]];
                    settings.pageLength = this._pageLength;
                    settings.buttons = [
                        {
                            extend: "copy",
                            name: "copy"
                        },
                        {
                            extend: "csv",
                            name: "csv"
                        }
                    ];
                    settings.createdRow = this._rowCreated;
                    settings.language = {
                        info: this._core.Locale.getTranslation('STR_WPT_DT_INFO'),
                        infoEmpty: this._core.Locale.getTranslation('STR_WPT_DT_INFO_EMPTY'),
                        infoFiltered: this._core.Locale.getTranslation('STR_WPT_DT_INFO_FILTERED'),
                        lengthMenu: this._core.Locale.getTranslation('STR_WPT_DT_LENGTH'),
                        zeroRecords: this._core.Locale.getTranslation('STR_WPT_DT_ZERO'),
                        paginate: {
                            first: this._core.Locale.getTranslation('STR_WPT_DT_PAGINATE_FIRST'),
                            last: this._core.Locale.getTranslation('STR_WPT_DT_PAGINATE_LAST'),
                            next: this._core.Locale.getTranslation('STR_WPT_DT_PAGINATE_NEXT'),
                            previous: this._core.Locale.getTranslation('STR_WPT_DT_PAGINATE_PREVIOUS')
                        }
                    };
                    (_d = this._componentResizeObserver) === null || _d === void 0 ? void 0 : _d.observe(this._componentDiv);
                    this._dataTable = $(table).DataTable(settings);
                    this._dataTable.on('search.dt', this._visibleDataChanged);
                    // This may be too soon, but we can't fire on _finishDataTable as that's also used on resize
                    this._fireVisibleDataChangedCallbacks('initial');
                    if (!this._componentResizeObserver) {
                        window.setTimeout(this._finishDataTable, this._core.getSleepTime());
                    }
                };
                this._finishDataTable = () => {
                    var _a, _b;
                    this._log.info("DataTableComponent._finishDataTable()");
                    this._headerDiv = this._componentDiv.querySelector('.dataTables_scrollHead');
                    this._headerTable = this._componentDiv.querySelector('.dataTables_scrollHead table.dataTable');
                    (_a = this._componentResizeObserver) === null || _a === void 0 ? void 0 : _a.observe(this._headerTable);
                    this._headerInnerDiv = this._componentDiv.querySelector('.dataTables_scrollHead .dataTables_scrollHeadInner');
                    this._bodyDiv = this._componentDiv.querySelector('.dataTables_scrollBody');
                    this._bodyTable = this._componentDiv.querySelector('.dataTables_scrollBody table.dataTable');
                    this._infoDivs = this._componentDiv.querySelectorAll('.dataTable-info');
                    let header = this._dataTable.table(undefined).header();
                    let headerRow = header.rows[0];
                    this._headerRow = headerRow;
                    this._filterRow = header.insertRow();
                    this._filterRow.classList.add("filterRow", WPTNamespace.HIDDEN_CLASS);
                    let columnLength = headerRow.cells.length;
                    let searchString = this._core.Locale.getTranslation('STR_WPT_SEARCH') + " ";
                    // Need to figure out here if we are operating with a hidden column 0 for sorting - if so indexing needs to be wrangled
                    let shimValue = (this._dataTable.column(0).visible()) ? 0 : 1;
                    //for (let i = startIndex; i < endIndex; i++) {
                    for (let i = 0; i < columnLength; i++) {
                        // TODO: check visibility state if responsive is used
                        // 
                        let headerCell = headerRow.cells[i];
                        (_b = this._headerWidthResizeObserver) === null || _b === void 0 ? void 0 : _b.observe(headerCell);
                        let filterCell = document.createElement('td');
                        this._filterRow.appendChild(filterCell);
                        let columnName = headerCell.innerText;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking for filter type of: " + columnName);
                        }
                        let filterType = this._filterSettings[columnName];
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got filter type: " + filterType);
                        }
                        let filterDiv = document.createElement("div");
                        filterCell.appendChild(filterDiv);
                        filterDiv.classList.add('wpt-input', 'wpt-input--full');
                        if (filterType && filterType === "Select") {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("building select filter...");
                            }
                            let optionIndex = 0;
                            let optionsData = {
                                Items: []
                            };
                            let isFirst = true;
                            this._dataTable.column(i + shimValue).data().unique().sort().each(value => {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("building entry for option with value: '" + value + "'");
                                }
                                if (isFirst) {
                                    if (value != '') {
                                        let optionData = {
                                            Id: optionIndex.toString(10),
                                            DisplayName: ''
                                        };
                                        optionsData.Items.push(optionData);
                                    }
                                    isFirst = false;
                                }
                                optionIndex++;
                                let optionData = {
                                    Id: optionIndex.toString(10),
                                    DisplayName: value
                                };
                                optionsData.Items.push(optionData);
                            });
                            let optionConfig = {
                                Options: optionsData,
                                ValueMustExist: true,
                                ShowClearIcon: true,
                                OptionsParent: this._container,
                                ChangeCallback: this._filterSelectListener
                            };
                            let filterOptionInput = new Widgets.ComponentOptionInput(this._core, filterDiv, this._parent, optionConfig);
                            filterOptionInput.present();
                            filterOptionInput.Input.placeholder = searchString + columnName;
                            filterOptionInput.Input.setAttribute("data-columnIdx", (i + shimValue).toString());
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("building text filter...");
                            }
                            let filterInput = document.createElement('input');
                            filterDiv.appendChild(filterInput);
                            filterInput.classList.add('wpt-input__input');
                            filterInput.placeholder = searchString + columnName;
                            filterInput.setAttribute('aria-label', searchString + columnName);
                            filterInput.setAttribute("data-columnIdx", (i + shimValue).toString());
                            let clearDiv = document.createElement('div');
                            filterDiv.appendChild(clearDiv);
                            clearDiv.classList.add('wpt-input__icons', 'wpt-input__icons--last');
                            let filterClear = document.createElement('span');
                            clearDiv.appendChild(filterClear);
                            filterClear.classList.add('wpt-input__icons-item', 'wpt-input__icons-item--hover-error', 'wpt-font', 'wpt-font-icon_CloseCircle');
                            filterClear.addEventListener('click', this._filterTextClearListener);
                            filterInput.addEventListener('keyup', this._filterTextListener);
                        }
                    }
                    this._dataTableReady = true;
                    if (this._isWaitingShowFilter) {
                        this._isWaitingShowFilter = false;
                        this.showFilterRow();
                    }
                    if (this._isWaitingHideFilter) {
                        this._isWaitingHideFilter = false;
                        this.hideFilterRow();
                    }
                    if (this._isWaitingClearSelection) {
                        this._isWaitingClearSelection = false;
                        this.clearRowSelection();
                    }
                    if (this._isWaitingCopyToClipboard) {
                        this._isWaitingCopyToClipboard = false;
                        this.copyDataToClipboard();
                    }
                    if (this._isWaitingSaveCsv) {
                        this._isWaitingSaveCsv = false;
                        this.saveDataAsCSV();
                    }
                    this._dataTable.columns.adjust();
                    if (!this._componentResizeObserver) {
                        this._widthWorkaround();
                    }
                    if (this._maxHeightResizeObserver) {
                        this._maxHeightResizeObserver.observe(this._headerDiv);
                        this._infoDivs.forEach(infoDiv => {
                            this._maxHeightResizeObserver.observe(infoDiv);
                        });
                    }
                    else {
                        window.setTimeout(this._calcMaxHeight, this._core.getSleepTime());
                    }
                };
                this._widthWorkaround = () => {
                    this._log.info("DataTableComponent._widthWorkaround()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("headertable width: " + this._headerTable.offsetWidth);
                        this._log.trace("initialWidth: " + this._initialWidth);
                    }
                    let testWidth = this._initialWidth ? this._initialWidth : this._headerTable.offsetWidth;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("using width: " + testWidth);
                        this._log.trace("checking if width workaround is needed, " + this._componentDiv.offsetWidth + " > " + testWidth);
                    }
                    if (this._componentDiv.offsetWidth > testWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("width workaround needed");
                        }
                        if (!this._initialWidth) {
                            this._initialWidth = this._headerTable.offsetWidth;
                        }
                        let widthSetting = this._componentDiv.offsetWidth + 'px';
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using width: " + widthSetting);
                        }
                        this._headerInnerDiv.style.width = widthSetting;
                        this._headerTable.style.width = widthSetting;
                        this._bodyTable.style.width = widthSetting;
                    }
                    else if (this._initialWidth && this._headerTable.offsetWidth > this._initialWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("width workaround used, but not needed anymore");
                        }
                        let widthSetting = this._initialWidth + 'px';
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using width: " + widthSetting);
                        }
                        this._headerInnerDiv.style.width = widthSetting;
                        this._headerTable.style.width = widthSetting;
                        this._bodyTable.style.width = widthSetting;
                    }
                };
                this._componentResized = () => {
                    this._log.info("DataTableComponent._componentResized()");
                    if (!this._dataTableReady) {
                        this._finishDataTable();
                    }
                    this._widthWorkaround();
                };
                this._calcMaxHeight = () => {
                    this._log.info("DataTableComponent._calcMaxHeight()");
                    let resultingHeight = this._maxHeight - 1;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting with max height: " + resultingHeight);
                    }
                    let marginHeight = this._core.Functions.getElementMarginHeight(this._componentDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got margin height: " + marginHeight);
                    }
                    resultingHeight -= marginHeight;
                    let paddingHeight = this._core.Functions.getElementPaddingHeight(this._componentDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got padding height: " + paddingHeight);
                    }
                    resultingHeight -= paddingHeight;
                    let headerHeight = this._core.Functions.getCompleteElementHeight(this._headerDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got header height: " + headerHeight);
                    }
                    resultingHeight -= headerHeight;
                    this._infoDivs.forEach(infoDiv => {
                        let infoHeight = this._core.Functions.getCompleteElementHeight(infoDiv);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got info height: " + infoHeight);
                        }
                        resultingHeight -= infoHeight;
                    });
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("ended with resulting height: " + resultingHeight);
                    }
                    if (resultingHeight > THRESHOLD_HEIGHT) {
                        this._bodyDiv.style.maxHeight = resultingHeight + "px";
                    }
                    else {
                        // remove max-height setting, because it's set during datatable creation with wrong value
                        this._bodyDiv.style.removeProperty("max-height");
                    }
                };
                this._headerResized = () => {
                    this._log.info("DataTableComponent._headerResized()");
                    let columnLength = this._headerRow.cells.length;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Executing header resize for ${columnLength} cells.`);
                    }
                    for (let i = 0; i < columnLength; i++) {
                        let headerCell = this._headerRow.cells[i];
                        let columnName = headerCell.innerText;
                        let filterCell = this._filterRow.cells[i];
                        let width = headerCell.offsetWidth;
                        let filterBorderWidth = this._core.Functions.getElementBorderWidth(filterCell);
                        let filterPaddingWidth = this._core.Functions.getElementPaddingWidth(filterCell);
                        let calcWidth = width;
                        if (filterBorderWidth > 0) {
                            calcWidth -= filterBorderWidth;
                        }
                        if (filterPaddingWidth > 0) {
                            calcWidth -= filterPaddingWidth;
                        }
                        let filterDiv = filterCell.querySelector('.wpt-input');
                        let currentWidth = filterDiv.style.width;
                        let resultingWidth = calcWidth + 'px';
                        if (currentWidth != resultingWidth) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting new width '" + resultingWidth + "' for filter input in column '" + columnName + "'");
                            }
                            filterDiv.style.width = resultingWidth;
                        }
                    }
                };
                this._filterTextListener = (event) => {
                    this._log.info("DataTableComponent._filterTextListener()");
                    let filterInput = event.currentTarget;
                    let filterText = filterInput.value;
                    let index = window.parseInt(filterInput.getAttribute("data-columnIdx"), 10);
                    this._filterColumn(index, filterText);
                };
                this._filterTextClearListener = (event) => {
                    this._log.info("DataTableComponent._filterTextClearListener()");
                    let filterClear = event.currentTarget;
                    let filterDiv = filterClear.parentElement.parentElement;
                    let filterInput = filterDiv.querySelector('input');
                    filterInput.value = "";
                    let triggerEvent = document.createEvent('Event');
                    triggerEvent.initEvent('keyup', true, true);
                    filterInput.dispatchEvent(triggerEvent);
                    filterInput.focus();
                };
                this._filterSelectListener = (event) => {
                    this._log.info("DataTableComponent._filterSelectListener()");
                    let filterInput = event.currentTarget;
                    let filterText = filterInput.value;
                    let index = window.parseInt(filterInput.getAttribute("data-columnIdx"), 10);
                    if (filterText) {
                        let regexText = '^' + $.fn.dataTable.util.escapeRegex(filterText) + '$';
                        this._filterColumn(index, regexText, true, true);
                    }
                    else {
                        this._filterColumn(index, filterText);
                    }
                };
                this._filterColumn = (index, text, redraw = true, regex = false) => {
                    let column = this._dataTable.column(index);
                    if (column.search() !== text) {
                        column.search(text, regex, !regex, !regex);
                        if (redraw) {
                            this._dataTable.draw();
                        }
                    }
                };
                this._clearFilter = () => {
                    this._log.info("DataTableComponent._clearFilter()");
                    let cellLength = this._filterRow.cells.length;
                    for (let c = 0; c < cellLength; c++) {
                        let cell = this._filterRow.cells[c];
                        let filterInput = cell.querySelector('input');
                        filterInput.value = '';
                        let index = window.parseInt(filterInput.getAttribute("data-columnIdx"), 10);
                        this._filterColumn(index, '', false);
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("draw after clear filter...");
                    }
                    this._dataTable.draw();
                };
                this._rowCreated = (row, data, index) => {
                    this._log.info("DataTableComponent._rowCreated()");
                    let tableRow = row;
                    let rowData = data;
                    let dataLength = rowData.Metadata.length;
                    for (let i = 0; i < dataLength; i++) {
                        let metadata = rowData.Metadata[i];
                        tableRow.setAttribute(metadata.Name, metadata.Value);
                    }
                    if (rowData.ClickCallback) {
                        tableRow.addEventListener('click', rowData.ClickCallback);
                    }
                    if (rowData.CreatedCallback) {
                        rowData.CreatedCallback(tableRow);
                    }
                };
                this.forceColumnAdjust = () => {
                    this._log.info("DataTableComponent.forceColumnAdjust()");
                    if (this._dataTable)
                        this._dataTable.columns.adjust();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DataTableComponent::constructor");
                this._isReady = false;
                this._isWaitingDisplayData = false;
                this._dataTableReady = false;
                this._isWaitingShowFilter = false;
                this._isWaitingHideFilter = false;
                this._isWaitingClearSelection = false;
                this._isWaitingCopyToClipboard = false;
                this._isWaitingSaveCsv = false;
                this._maxHeight = maxHeight;
                if (window.ResizeObserver) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("browser supports ResizeObserver");
                    }
                    this._componentResizeObserver = new ResizeObserver(this._componentResized);
                    if (this._maxHeight !== null && this._maxHeight > 0) {
                        this._maxHeightResizeObserver = new ResizeObserver(this._calcMaxHeight);
                    }
                    this._headerWidthResizeObserver = new ResizeObserver(this._headerResized);
                }
                else {
                    console.warn("browser doesn't support ResizeObserver");
                }
                if (!ComponentDataTable.Html) {
                    core.Loader.getVersionedHTML('widgets/components/dataTable.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            // Only takes effect on initial data load/view
            set PageLength(value) {
                this._pageLength = value;
                // TODO - allow dynamic layout change if module allows?
            }
            get VisibleDataInitialisedCallback() {
                return this._visibleDataInitialisedCallback;
            }
            set VisibleDataInitialisedCallback(value) {
                this._visibleDataInitialisedCallback = value;
            }
            get VisibleDataFilteredCallback() {
                return this._visibleDataFilteredCallback;
            }
            set VisibleDataFilteredCallback(value) {
                this._visibleDataFilteredCallback = value;
            }
        }
        ComponentDataTable.Html = null;
        Widgets.ComponentDataTable = ComponentDataTable;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
